import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from "vue";

interface IProps {
  text?: string;
  btnType?: "btn-primary" | "btn-gray";
  onClickEvent?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Btn',
  props: {
    text: {},
    btnType: { default: "btn-primary" },
    onClickEvent: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["btn", [{ 'cursor-pointer': _ctx.onClickEvent }, _ctx.btnType]]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickEvent && _ctx.onClickEvent(...args)))
  }, [
    _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})